import React, { useEffect, useRef, useState } from "react"
import mapboxgl from "mapbox-gl"
import SbEditable from "storyblok-react"
import classnames from "classnames"

import "mapbox-gl/dist/mapbox-gl.css"
import styles from "./styles.module.scss"

import TextRenderer from "./../TextRenderer"

mapboxgl.accessToken =
  "pk.eyJ1IjoidGlqc2x1aXRzZSIsImEiOiJja2dvczQ0YjkwM2F6MnF0ZDF5ZDc5cmgzIn0.lUty_APItLA9uDIljelmfQ"

const CustomMap = (props) => {
  const [activeIndex, setActiveIndex] = useState(0)

  const mapNode = useRef(null)
  const mapRef = useRef(null)

  useEffect(() => {
    const map = new mapboxgl.Map({
      container: mapNode.current,
      style: "mapbox://styles/tijsluitse/ckgormh301y9g19prgzlgnasb",
      center: [41, 21],
      zoom: 1,
      attributionControl: false,
    })

    mapRef.current = map
    window.map = map

    map.scrollZoom.disable()

    map.on("load", () => {
      map.addLayer({
        id: "countries",
        source: {
          type: "vector",
          url: "mapbox://tijsluitse.49vrs5tl",
        },
        "source-layer": "ne_10m_admin_0_countries-drk9v9",
        type: "fill",
        paint: {
          "fill-outline-color": "#fff",
          "fill-color": "#000",
        },
      })

      map.setFilter(
        "countries",
        ["in", "ADM0_A3_IS"].concat(
          props.blok.years ? props.blok.years[0].countries : ["USA"]
        )
      )

      var adminLayers = [
        "admin-0-boundary",
        "admin-1-boundary",
        "admin-0-boundary-disputed",
        "admin-1-boundary-bg",
        "admin-0-boundary-bg",
      ]

      adminLayers.forEach(function (adminLayer) {
        map.setFilter(adminLayer, [
          "match",
          ["get", "worldview"],
          ["all", "IN"],
          true,
          false,
        ])
      })

      map.on("click", "countries", (mapElement) => {
        const countryCode = mapElement.features[0].properties.ADM0_A3_IS

        fetch(`https://restcountries.eu/rest/v2/alpha/${countryCode}`)
          .then((data) => data.json())
          .then((country) => {
            const html = `<div><p class='body'>${country.name}</p></div>`
            new mapboxgl.Popup()
              .setLngLat(mapElement.lngLat)
              .setHTML(html)
              .addTo(map)
          })
      })
    })

    return () => {
      map.remove()
    }
  }, [])

  const filterItems = (countries, index) => {
    map.setFilter("countries", ["in", "ADM0_A3_IS"].concat(countries))
    setActiveIndex(index)
  }

  const headingClasses = classnames({
    [styles["map__heading"]]: true,
    [styles["map__heading--center"]]: props.blok.text_align == "center",
  })

  return (
    <SbEditable content={props.blok}>
      <section className={styles["map"]}>
        <div className="container">
          <TextRenderer className={headingClasses} text={props.blok.heading} />
        </div>
        <div className={styles["map__wrapper"]}>
          <ul className={styles["map__filter"]}>
            {props.blok.years &&
              props.blok.years.map((blok, i) => {
                const buttonClasses = classnames({
                  button: true,
                  body: true,
                  [styles["map__filter-button"]]: true,
                  [styles["map__filter-button--active"]]: i == activeIndex,
                })

                return (
                  <SbEditable key={i} content={blok}>
                    <li className={styles["map__filter-item"]}>
                      <button
                        onClick={() => filterItems(blok.countries, i)}
                        className={buttonClasses}
                      >
                        {blok.year} ({blok.countries.length})
                      </button>
                    </li>
                  </SbEditable>
                )
              })}
          </ul>
          <div ref={mapNode} className={styles["map__map"]}></div>
        </div>
      </section>
    </SbEditable>
  )
}

export default CustomMap
